import { useModalStackStore } from './store'

function useModalStack() {
    const addModal = useModalStackStore((state) => state.addModal)
    const removeModal = useModalStackStore((state) => state.removeModal)
    const modalIsOpen = useModalStackStore((state) => state.modalIsOpen)

    return { addModal, removeModal, modalIsOpen }
}

export default useModalStack
